var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtHypercube = function SvgTtHypercube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "inherit",
      height: "inherit"
    },
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m29 15.5-2.25-1.312M29 15.5v2.25m0-2.25-2.25 1.313M11 15.5l2.25-1.312M11 15.5l2.25 1.313M11 15.5v2.25m9 3 2.25-1.312M20 20.75l-2.25-1.312M20 20.75V23m0 6.75 2.25-1.312M20 29.75V27.5m0 2.25-2.25-1.312m0-16.875L20 10.25l2.25 1.313M29 22.25v2.25l-2.25 1.313m-13.5 0L11 24.5v-2.25"
  })));
};
export { SvgTtHypercube as ReactComponent };
export default __webpack_public_path__ + "a89e014fa4d380457fb9a4f4d4b9f395.svg";